"use client";

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { buildEsimCollectionPublicListBody } from "@/utils/esim/buildEsimSearchBody";
import { useEffect, useRef } from "react";

/**
 * "Danh mục eSIM nổi bật" (`POST /esim/collection/public/list`, api_guide mục 2). Fetch once and
 * rely on the `called` flag — same reasoning as `useEsimCatalogFilters`.
 */
export const useEsimFeaturedCollections = (limit = 6) => {
  const dispatch = useAppDispatch();
  const requestedRef = useRef(false);
  const { collections, loading, called } = useAppSelector((state) => ({
    collections: state.esim.esim_collection_public_list.data.collections,
    loading: state.esim.esim_collection_public_list.loading,
    called: state.esim.esim_collection_public_list.called,
  }));

  useEffect(() => {
    if (called || requestedRef.current) return;
    requestedRef.current = true;
    dispatch(
      thunks.esim_collection_public_list({
        body: { TYPE: "JSON", ...buildEsimCollectionPublicListBody({ limit, esimLimit: 1 }) },
      }),
    );
  }, [called, dispatch, limit]);

  return { collections, loading };
};
